<template>
  <div
    v-show="!doctor.deleteDoctor"
    :class="[
      style.doctorCard,
      {
        [style.active]: active,
        [style.lastCard]: isLast
      }
    ]"
  >
    <section
      :id="doctor._id"
      :class="style.profileAndSave"
      @click="$emit('openDoctor', doctor)"
    >
      <div :class="style.imgNameBlock">
        <div :class="style.imgBlock">
          <div
            :class="style.imgProfile"
            :style="{
              backgroundImage: doctorAvatar ? `url(${doctorAvatar})` : 'none'
            }"
          />

          <span :class="getClassOnlineDoctor(doctor)" />
        </div>

        <h4 :class="style.name" v-text="doctor.name" />
      </div>

      <span
        :class="style.specialization"
        v-text="
          doctor.specialization?.length
            ? doctor.specialization.join(', ')
            : 'Специализация врача'
        "
      />

      <div :class="style.buttonsDoctor" @click.stop>
        <SwitchComponent
          :modelValue="currentStatus"
          @update:modelValue="$emit('toggleStatus', {doctor, value: $event})"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./DoctorCard.module.scss";
import {getClassOnlineDoctor} from "../DoctorsScript";
import type {doctor} from "../DoctorsType";
import {DOMAIN} from "@/http";
import SwitchComponent from "@/elements/UI/input/Switch/SwitchComponent.vue";
import {LegacyDoctorPhoto} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "DoctorCard",
  components: {
    SwitchComponent
  },
  emits: ["openDoctor", "toggleStatus"],
  props: {
    doctor: {
      type: Object as PropType<doctor>,
      required: true
    },
    bufferStatus: {
      type: Object as PropType<Record<string, boolean>>,
      default: () => ({})
    },
    isLast: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style,
      getClassOnlineDoctor,
      DOMAIN
    };
  },
  methods: {
    normalizeDoctorPhoto(photo: LegacyDoctorPhoto): string {
      if (typeof photo === "string") {
        return photo;
      }

      if (photo && typeof photo === "object" && !Array.isArray(photo)) {
        if (typeof photo.circle === "string" && photo.circle) {
          return photo.circle;
        }

        if (typeof photo.square === "string" && photo.square) {
          return photo.square;
        }

        const firstStringPhoto = Object.values(photo).find((value) => {
          return typeof value === "string" && value;
        });

        return typeof firstStringPhoto === "string" ? firstStringPhoto : "";
      }

      return "";
    }
  },
  computed: {
    currentStatus(): boolean {
      if (!this.doctor?._id) {
        return false;
      }

      if (this.bufferStatus[this.doctor._id] !== undefined) {
        return this.bufferStatus[this.doctor._id];
      }

      return !!this.doctor.status;
    },

    doctorAvatar(): string {
      const photoName = this.normalizeDoctorPhoto(
        (this.doctor as unknown as {photo?: LegacyDoctorPhoto})?.photo
      );

      if (!photoName) {
        return "";
      }

      return `https://${this.DOMAIN}/api/img?size=250x250&name=${photoName}`;
    }
  }
});
</script>
